import React from 'react';
import EditorContext from './EditorContext';
import { useContextSelector } from 'use-context-selector';
import { Heading, Stack } from '@chakra-ui/react';
import TempContact from '../TempContact';

const WritingTo = () => {
  const id = useContextSelector(EditorContext, (c) => c.id);
  const firstName = useContextSelector(EditorContext, (c) => c.document?.first_name);
  const lastName = useContextSelector(EditorContext, (c) => c.document?.last_name);
  const tempName = useContextSelector(EditorContext, (c) => c.document?.temp_contact_name);

  return (
    <>
      {firstName && (
        <Heading size="md" p={1}>
          Writing to: {firstName} {lastName}
        </Heading>
      )}
      {tempName && (
        <Stack ml={1} spacing={1} direction="row" alignItems="top">
          <Heading size="md">Writing to:</Heading>
          <TempContact letterId={id} name={tempName} />
        </Stack>
      )}
    </>
  );
};

export default WritingTo;
